import {supplyEventInAction} from "@/components/common/controlBar/controlBarDialog/event/washData.js";

export function washData_image_image1(walkedNode) {

  supplyEventInAction(walkedNode)
}
